var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h1",on:{"click":function($event){return _vm.to_api()}}},[_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }